import { Spin } from 'antd';
import React from 'react';
import { useAppSelector } from '../hooks/reduxHooks';

const GlobalLoading: React.FC = () => {
  const loading = useAppSelector((state) => state.loading.isLoading);

  if (!loading) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <Spin size="large" tip="Yükleniyor..." />
    </div>
  );
};

export default GlobalLoading;